import Router from "./routes";
import { HashRouter } from "react-router-dom";
import { SWRConfig } from "swr";
import { observer, inject } from "mobx-react";
import { fetcher } from "./services/fetcher";
import { useEffect } from "react";
import { setLocalStore } from "./tool/localStore";
import { getUrlParamsToJson } from "./tool";

function App({ store }) {
  const urlParams = getUrlParamsToJson();
  const { token = "" } = urlParams;

  useEffect(() => {
    if (token) {
      localStorage.setItem("login", "login");
      setLocalStore("token", token);
      store.getBalanceInfo();
    }
  }, [token]);

  return (
    <SWRConfig
      value={{
        fetcher,
        revalidateOnFocus: false,
      }}
    >
      <HashRouter>
        <Router />
      </HashRouter>
      <div className={`loading ${store.loadingCount < 1 ? "hide" : ""}`}>
        <img src={require("./assets/imgs/loading.gif")} alt="" />
      </div>
    </SWRConfig>
  );
}

export default inject("store")(observer(App));
